/** @format */
import React from 'react';
import { PageContainer, TabListFp } from 'components';
import { useStyles } from '../style';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { Tab } from '@mui/material';
import AllRequests from '../AllReceivedRequests';
import AsServiceSet from '../AsServiceSet';
import useCustomHook from '../hooks';
import { getDynamicObjectAction , constBreadCrumbsTitle } from 'utility';

const RequestReceivedPage = () => {
  const classes = useStyles();

  const { activeTab, setActiveTab } = useCustomHook();
  const actionsList =
    getDynamicObjectAction([
      'requestSetServiceDefinePage',
      'exportRequestSetServiceDefinePage'

    ])
  
  const hint =
    'در این صفحه لیست درخواست‌هایی که از مجموعه سرویس‌های شما شده را می‌توانید مشاهده کنید و آنها را تعیین وضعیت کنید.';

  return (
    <PageContainer
      title="لیست درخواست‌های دریافتی"
      pageKey="receivedRequests"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.RECEIVED_REQUEST_WEBSERVICE}
    >

      {actionsList['requestSetServiceDefinePage'] && (

        <TabContext value={activeTab}>
          <TabListFp
            style={{ marginTop: -15 }}
            onChange={(e, v) => setActiveTab(v)}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="به تفکیک مجموعه سرویس" value="1" />
            <Tab label="همه درخواست‌ها" value="2" />
          </TabListFp>

          <TabPanel value="1" className={classes.tabPanel}>
            <AsServiceSet />
          </TabPanel>
          <TabPanel value="2" className={classes.tabPanel}>
            <AllRequests />
          </TabPanel>
        </TabContext>
      )}
    </PageContainer>
  );
};

export default RequestReceivedPage;
